module.exports = __webpack_public_path__ + "static/media/lepes6.eaf38fef.png";